import type { AppBrandingDto } from "@/api/types";

export const DEFAULT_APP_BRANDING: AppBrandingDto = "areaOfPeople";
